import React from 'react';
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/20/solid'

function DescriptionComponent() {

    return (
        <div>

            <div className="bg-white py-4 sm:py-12">
                <div className="mx-auto max-w-7xl">
                    <div className="relative overflow-hidden bg-white px-6 py-20 shadow-xl sm:rounded-3xl sm:px-10 sm:py-24 md:px-12 lg:px-20">
                        <div className="absolute inset-0 bg-[#eeeeee] mix-blend-multiply" />
                        <div aria-hidden="true" className="absolute -top-56 -left-80 transform-gpu blur-3xl">
                            <div
                                style={{
                                    clipPath:
                                        'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                }}
                                className="aspect-1097/845 w-274.25 bg-linear-to-r from-[#fff] to-[#FFF] opacity-[0.45]"
                            />
                        </div>
                        <div
                            aria-hidden="true"
                            className="hidden md:absolute md:bottom-16 md:left-200 md:block md:transform-gpu md:blur-3xl"
                        >
                            <div
                                style={{
                                    clipPath:
                                        'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                }}
                                className="aspect-1097/845 w-274.25 bg-linear-to-r from-[#fff] to-[#fff] opacity-25"
                            />
                        </div>
                        <div className="relative mx-auto max-w-2xl lg:mx-0">
                            <figure>
                                <blockquote className="text-sm font-semibold  sm:text-sm text-justify  ">
                                    <h2 className="text-2xl font-semibold tracking-tight text-pretty  sm:text-2xl">
                                        ¿Tienes una idea que puede mejorar la forma en que trabajamos?
                                        <br/>¡Queremos conocerla!
                                    </h2>
                                    <br/>

                                    En Grupo Brame, creemos que la innovación comienza contigo. Esta iniciativa busca fomentar una cultura de innovación colaborativa, donde cada idea cuenta, se escucha y puede convertirse en una solución real que impacte positivamente a la empresa.
                                    <br/><br/>
                                    Comparte tu iniciativa y sé parte del cambio.
                                    <br/><br/>
                                    <h2 className="text-2xl font-semibold tracking-tight  sm:text-2xl">
                                        ¡Es tu momento de innovar!
                                    </h2>

                                </blockquote>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DescriptionComponent;

/*
* <figure>
                                <blockquote className="mt-6 text-md font-semibold text-white sm:text-md">
                                    <h2 className="text-2xl font-semibold tracking-tight text-pretty text-white sm:text-2xl">
                                        ¿Tienes una idea que puede mejorar la forma en que trabajamos? ¡Queremos conocerla!
                                    </h2>
                                    <br/>

                                        En Grupo Brame, creemos que la innovación comienza contigo. Esta iniciativa busca fomentar una cultura de innovación colaborativa, donde cada idea cuenta, se escucha y puede convertirse en una solución real que impacte positivamente a la empresa.
                                        <br/>
                                        Un comité evaluará todas las propuestas según su viabilidad e impacto, y las mejores serán reconocidas con un premio especial.
                                        <br/>
                                        Comparte tu iniciativa y sé parte del cambio.
                                        <br/><br/>
                                        <h2 className="text-2xl font-semibold tracking-tight text-white sm:text-2xl">
                                            ¡Es tu momento de innovar! Llena el siguiente formulario:
                                        </h2>

                                </blockquote>
                            </figure>
* */